module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C114"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "C117"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/05_Foreword#page_ix"
    }
  }, [_vm._v("Foreword")]), _vm._v(" "), _c('em', [_vm._v("by David Bordwell")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_Introduction#page_xv"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_3_Women#page_3"
    }
  }, [_vm._v("3 Women")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_Ace_in_the_Hole#page_7"
    }
  }, [_vm._v("Ace in the Hole")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_Adaptation#page_11"
    }
  }, [_vm._v("Adaptation")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('a', {
    attrs: {
      "href": "#/html/11_After_Dark__My_Sweet#page_15"
    }
  }, [_vm._v("After Dark, My Sweet")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('a', {
    attrs: {
      "href": "#/html/12_After_Hours#page_19"
    }
  }, [_vm._v("After Hours")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('a', {
    attrs: {
      "href": "#/html/13_The_Age_of_Innocence#page_23"
    }
  }, [_vm._v("The Age of Innocence")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('a', {
    attrs: {
      "href": "#/html/14_Army_of_Shadows#page_27"
    }
  }, [_vm._v("Army of Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_Atlantic_City#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Atlantic City")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Au_Revoir_les_Enfants#page_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Au Revoir les Enfants")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Babel#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Babel")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_The_Band_Wagon#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Band Wagon")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_Baraka#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baraka")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_The_Battle_of_Algiers#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle of Algiers")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_Bergman_s_Trilogy_1__Through_a_G#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bergman’s Trilogy 1: Through a Glass Darkly")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_Bergman_s_Trilogy_2__Winter_Ligh#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bergman’s Trilogy 2: Winter Light")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_Bergman_s_Trilogy_3__The_Silence#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bergman’s Trilogy 3: The Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_The_Best_Years_of_Our_Lives#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Best Years of Our Lives")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_The_Big_Red_One#page_72",
      "id": "page_vi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Big Red One")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_Blade_Runner__The_Final_Cut#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blade Runner: The Final Cut")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/27_Cabiria#page_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cabiria")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/28_Cat_People#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cat People")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/29_Chimes_at_Midnight#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chimes at Midnight")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/30_Chop_Shop#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chop Shop")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/31_Chuck_Jones__Three_Cartoons#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chuck Jones: Three Cartoons")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/32_Cool_Hand_Luke#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cool Hand Luke")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/33_Crimes_and_Misdemeanors#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crimes and Misdemeanors")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/34_Crumb#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crumb")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/35_Dark_City#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dark City")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/36_The_Dead#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/37_Diva#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diva")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/38_Dog_Day_Afternoon#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dog Day Afternoon")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/39_The_Double_Life_of_Veronique#page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Double Life of Veronique")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/40_Easy_Rider#page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Rider")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/41_El_Norte#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Norte")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/42_El_Topo#page_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("El Topo")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/43_The_Enigma_of_Kaspar_Hauser#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Enigma of Kaspar Hauser")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/44_Exotica#page_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exotica")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/45_Fanny_and_Alexander#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fanny and Alexander")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/46_Faust#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faust")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/47_Fitzcarraldo#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fitzcarraldo")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/48_Forbidden_Games#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forbidden Games")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/49_The_Godfather__Part_II#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Godfather: Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/50_The_Great_Dictator#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Dictator")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/51_Groundhog_Day#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Groundhog Day")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/52_Howards_End#page_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Howards End")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/53_Inherit_the_Wind#page_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inherit the Wind")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/54_Johnny_Guitar#page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnny Guitar")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/55_Juliet_of_the_Spirits#page_197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Juliet of the Spirits")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/56_Killer_of_Sheep#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Killer of Sheep")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/57_La_Belle_Noiseuse#page_205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("La Belle Noiseuse")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/58_L_A__Confidential#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L.A. Confidential")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/59_The_Last_Picture_Show#page_213",
      "id": "page_vii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Picture Show")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/60_Last_Tango_in_Paris#page_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Tango in Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/61_The_Last_Temptation_of_Christ#page_222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Temptation of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/62_Late_Spring#page_226",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Late Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/63_Leolo#page_230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leolo")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/64_The_Long_Goodbye#page_234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Long Goodbye")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/65_Magnolia#page_239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magnolia")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/66_The_Marriage_of_Maria_Braun#page_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Marriage of Maria Braun")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/67_Mephisto#page_248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mephisto")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/68_Mishima__A_Life_in_Four_Chapters#page_252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mishima: A Life in Four Chapters")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/69_Mon_Oncle_Antoine#page_256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mon Oncle Antoine")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/70_Moolaade#page_260",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moolaade")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/71_My_Fair_Lady#page_264",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Fair Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/72_My_Man_Godfrey#page_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Man Godfrey")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/73_Nanook_of_the_North#page_273",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nanook of the North")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/74_Ordet#page_277",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ordet")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/75_Out_of_the_Past#page_281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Out of the Past")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/76_Pan_s_Labyrinth#page_286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pan’s Labyrinth")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/77_Paths_of_Glory#page_290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paths of Glory")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/78_The_Phantom_of_the_Opera#page_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phantom of the Opera")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/79_Pixote#page_299",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pixote")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/80_Playtime#page_303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Playtime")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/81_A_Prairie_Home_Companion#page_307",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prairie Home Companion")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/82_Rebel_Without_a_Cause#page_311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rebel Without a Cause")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/83_The_Red_Shoes#page_315",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Red Shoes")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/84_Ripley_s_Game#page_319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ripley’s Game")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/85_The_River__Le_Fleuve#page_323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The River (Le Fleuve)")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/86_Rocco_and_His_Brothers#page_327",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rocco and His Brothers")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/87_Safety_Last#page_331",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safety Last")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/88_Samurai_Rebellion#page_335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samurai Rebellion")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/89_Sansho_the_Bailiff#page_339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sansho the Bailiff")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/90_Santa_Sangre#page_343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Santa Sangre")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/91_The_Scarlet_Empress#page_347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scarlet Empress")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/92_Secrets___Lies#page_351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secrets & Lies")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/93_The_Shining#page_355",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shining")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/94_The_Terrorist#page_359",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Terrorist")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/95_The_Thief_of_Bagdad#page_363",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Thief of Bagdad")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/96_Top_Hat#page_367",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Top Hat")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/97_Triumph_of_the_Will#page_371",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triumph of the Will")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/98_Vengeance_Is_Mine#page_375",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vengeance Is Mine")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/99_Waking_Life#page_379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waking Life")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/100_Werckmeister_Harmonies#page_383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Werckmeister Harmonies")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/101_What_Ever_Happened_to_Baby_Jane#page_387",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Ever Happened to Baby Jane?")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/102_Withnail___I#page_391",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Withnail & I")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/103_A_Woman_s_Tale#page_395",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Woman’s Tale")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/104_Woodstock#page_399",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Woodstock")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/105_WR_Mysteries_of_the_Organism#page_403",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WR—Mysteries of the Organism")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/106_A_Year_of_the_Quiet_Sun#page_407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Year of the Quiet Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "C115"
  }, [_c('span', {
    attrs: {
      "href": "#/html/107_Yojimbo#page_411",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yojimbo")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a085e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_CONTENTS.vue
// module id = 66
// module chunks = 0